import React from "react";
import { withTranslation } from "react-i18next";
import {
  LocalStorageService,
  ClientContractService,
  WorkflowService,
  WorkflowMessagesService,
  RevisionClientContractService,
} from "../../../services";
import { NegotiateContractView } from "../../views";
import { socket } from "../../../Context";
import { getNavigatorTimezone } from "../../../utils";

class NegoiateContractAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      user: {},
      token: "",
      message: "",
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      showWarningRequesting: false,
      status: "",
      contract: {},
      workflowExecutionInfo: {},
      path: "/",
      clientContractId: "",
      errorMessage: "",
      usersChat: {},
      conversation: [],
      membersChat: [],
      changesContract: [],
      membersWorkflow: []
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  clientContractService = new ClientContractService(this.url);
  workflowService = new WorkflowService(this.url);
  workflowMessagesService = new WorkflowMessagesService(this.url);
  revisionClientContractService = new RevisionClientContractService(
    process.env.REACT_APP_MIFIRMA_API
  );

  workflowExecutionId = "";
  clientContractId = "";
  idAuthorMessage = 0;
  timezone = getNavigatorTimezone()


  async componentDidMount() {
    let urlArr = window.location.href.split("/");
    this.workflowExecutionId = urlArr[urlArr.length - 1].includes('?') ? urlArr[urlArr.length - 1].split('?')[0] : urlArr[urlArr.length - 1];
    this.clientContractId = urlArr[urlArr.length - 2];

    this.toggleLoadingRequesting(true);
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    //call sockets
    socket.on("messages", (data) => this.addNewMessageSocket(data));
    socket.emit("joinRoom", this.workflowExecutionId)
    this.getContarctData();
    this.getWorkExecutionId();
    this.getMessages();
    this.getChangesInContract();
    this.getMembersWorkflow();

    this.setState({
      loading: false,
      token: this.token,
      user: this.user,
    });
  }

  async componentWillUnmount() {
    socket.emit("leaveRoom", this.workflowExecutionId)
  }

  forceRefresh = () => {
    this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
  };

  //Function loading dialog
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  //Function completed dialog

  toggleCompletedRequesting = (value, message) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
          });
        }, 4000);
      }
    );
  };

  //Funtion error dialog
  toggleErrorRequesting = async (value, message) => {
    this.setState({
      showErrorRequesting: value,
      message: message,
    });
    setTimeout(() => {
      this.setState({
        showErrorRequesting: false,
        message: "",
      });
      this.props.history.push("/");
    }, 4000);
  };

  //Funtion warning dialog
  toggleWarningRequesting = (value, message) => {
    this.setState(
      {
        showWarningRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showWarningRequesting: false,
            message: "",
          });
        }, 4000);
      }
    );
  };

  async getContarctData() {
    let clientContractId = this.clientContractId;
    this.setState({ clientContractId: clientContractId });
    this.setState({
      message:
        "Ocurrió un erro al consultar la información de los cambios al contrato",
    });
    try {
      let contract = await this.clientContractService.getContractById(
        clientContractId,
        this.token
      );
      if (contract && contract.data && Number(contract.statusCode) === 200) {
        this.setState({
          contract: contract.data,
        });
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
      }
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true);
    }
  }

  async getWorkExecutionId() {
    let workflowExecutionId = this.workflowExecutionId;
    this.setState({ workflowExecutionId: workflowExecutionId });
    this.setState({
      message: "Ocurrió un erro al consultar la información del workflow",
    });
    try {
      let workflowExecution =
        await this.workflowService.getWorkFlowExecutionById(
          workflowExecutionId,
          this.token
        );
      if (
        workflowExecution &&
        workflowExecution.data &&
        Number(workflowExecution.statusCode) === 200
      ) {
        let statusCurrent =
          workflowExecution.data.workflowStatusDescriptions.statusCurrent
            .status;
        let currenteName =
          workflowExecution.data.workflowStatusDescriptions.statusCurrent.name;
        this.setState({
          workflowExecutionInfo: workflowExecution.data,
          titleView: currenteName,
          status: statusCurrent,
        });
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
      }
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true);
    }
  }

  getMessages = async () => {
    this.setState({
      message: "Ocurrió un error a consultar los mensajes",
    });
    let user = {};

    try {
      //Get message and members chat
      let workflowMessage =
        await this.workflowMessagesService.getWorkFlowExecutionMessage(
          this.workflowExecutionId,
          this.timezone,
          this.token
        );
      if (
        workflowMessage &&
        workflowMessage.data &&
        Number(workflowMessage.statusCode) === 200
      ) {
        //Filter out duplicated members
        let membersChat = workflowMessage.data.workflowExecutionMembers.filter((member, index) =>
          workflowMessage.data.workflowExecutionMembers.findIndex((item) => item.email === member.email) === index
        );
        //users chat
        membersChat.map((member) => {
          member.id = member.workflowExecutionMemberId;
          member.avatarUrl = member.profilePicture;
          member.name = member.firstName + " " + member.firstLastName;
          member.avatarAltText = member.firstName + " " + member.firstLastName;
          if (this.user.userMetaData.userA3Cloud.email === member.email) {
            this.idAuthorMessage = member.id;
            user = member;
          }
          return membersChat;
        });

        //Message chat
        workflowMessage.data.workflowExecutionMessages.map((member) => {
          member.author = {
            name: member.firstName + " " + member.firstLastName,
            id: member.workflowExecutionMemberId,
            avatarUrl: member.profilePicture,
          };
          member.timestamp = new Date(member.createdDate);
          member.text = member.workflowExecutionMemberMessage;
          member.id = member.workflowExecutionMemberId;
          member.name = member.firstName + " " + member.firstLastName;
          member.avatarUrl = member.profilePicture;
          if (member.workflowExecutionMemberMessageDoc.length > 0) {
            member.attachments = [
              {
                name: member.workflowExecutionMemberMessageDoc[0]?.documentName,
                site: member.workflowExecutionMemberMessageDoc[0]?.documentPath,
              },
            ];
          }
          return workflowMessage.data.workflowExecutionMessages;
        });
        this.setState({
          membersChat: membersChat,
          conversation: workflowMessage.data.workflowExecutionMessages,
          usersChat: user,
        });
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
      }
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true);
    }
  };

  //Function to create message
  createMessage = async (messagesChat, fileContent) => {
    let data = new FormData();
    data.append("workflowExecutionId", this.workflowExecutionId);
    data.append("workflowExecutionMemberId", this.idAuthorMessage);
    data.append("message", messagesChat.text);
    data.append("documento", fileContent);
    data.append("timezone", this.timezone)

    await this.workflowMessagesService.createWorkflowExecutionNewMessage(
      data,
      this.token
    );
  };

  //add a new meessage to conversation when sockets send a mew message
  addNewMessageSocket = (message) => {
    let copyConversation = [...this.state.conversation];
    let indexMessage = copyConversation.length;
    let newMessage = {
      author: {
        name: `${message.firstName} ${message.firstLastName}`,
        id: Number(message.workflowExecutionMemberId),
        avatarUrl: message.profilePicture,
      },
      timestamp: message.workflowExcecutionMemberMessage
        ? new Date(message.workflowExcecutionMemberMessage.createdDate)
        : new Date(
          message.workflowExecutionMemberMessageDocName[0].createdDate
        ),
      text: message.workflowExcecutionMemberMessage.message,
      id: Number(message.workflowExecutionMemberId),
      name: `${message.firstName} ${message.firstLastName}`,
      avatarUrl: message.profilePicture,
      workflowExecutionMemberId: Number(message.workflowExecutionMemberId),
      workflowExecutionMemberMessage:
        message.workflowExcecutionMemberMessage.message === "" ||
          message.workflowExcecutionMemberMessage.message === "undefined"
          ? null
          : message.workflowExcecutionMemberMessage.message,
      email: message.email,
      firstName: message.firstName,
      firstLastName: message.firstLastName,
      profilePicture: message.profilePicture,
      selectionIndex: indexMessage,
    };

    if (message.workflowExecutionMemberMessageDocName.length > 0) {
      newMessage.workflowExecutionMemberMessageDoc = [
        {
          name: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocName
            : "",
          site: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocURL
            : "",
        },
      ];
      newMessage.attachments = [
        {
          name: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocName
            : "",
          site: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocURL
            : "",
        },
      ];
    }

    copyConversation.push(newMessage);
    this.setState({
      conversation: copyConversation,
    });
  };

  getChangesInContract = async () => {
    this.setState({
      message:
        "Ocurrió un erro al consultar la información de los cambios al contrato",
    });

    //Get timezone from navegator
    try {
      let changes =
        await this.revisionClientContractService.getRevisionContract(
          this.workflowExecutionId,
          this.timezone,
          this.token
        );
      if (changes && changes.data && Number(changes.statusCode) === 200) {
        this.setState({
          changesContract: changes.data,
        });
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
      }
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true);
    }
  };

  getMembersWorkflow = async () => {
    let errorMessage = 'Ocurrió un error al consultar los miembros del flujo'

    try {
      let members = await this.workflowService.getMembersWorkflow(this.workflowExecutionId, this.token)
      if (members && members.data && Number(members.statusCode) === 200) {
        this.setState({
          membersWorkflow: members.data
        })
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(true, errorMessage)
      setTimeout(() => {
        this.toggleErrorRequesting()
      }, 3000)
    }
  }

  render() {
    return (
      <NegotiateContractView
        showLoadingRequesting={this.showLoadingRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        showCompletedRequesting={this.showCompletedRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        showErrorRequesting={this.showErrorRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        showWarningRequesting={this.showWarningRequesting}
        toggleWarningRequesting={this.toggleWarningRequesting}
        createMessage={this.createMessage}
        path={this.state.path}
        {...this.state}
      />
    );
  }
}

export default withTranslation()(NegoiateContractAction);
